import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CustomIJitsiMeetExternalApi } from '../../Jitsi/JitsiHelper';

interface JitsiMeetSliceType {
  activePanel: "chat" | "participants" | "tileView" | null;
  apiRef: CustomIJitsiMeetExternalApi | null;
  chatIndication: boolean;
  isMeetjoined: boolean;
  jitsiHostId: string | undefined;
  participantLeft: boolean,
  participantJoin : boolean
}

const initialState: JitsiMeetSliceType = {
  activePanel: null,
  apiRef: null,
  chatIndication: false,
  isMeetjoined: false,
  jitsiHostId: undefined,
  participantLeft : false,
  participantJoin : false
};

const JitsiMeetSlice = createSlice({
  name: 'JitsiMeetSlice',
  initialState,
  reducers: {
    setActivePanel(state, action: PayloadAction<{ activePanel: "chat" | "participants" | "tileView" | null }>) {
      state.activePanel = action.payload.activePanel;
    },
    setApiRef(state, action: PayloadAction<{ apiRef: CustomIJitsiMeetExternalApi | null}>) {
      state.apiRef = action.payload.apiRef;
    },
    setChatIndication(state, action: PayloadAction<{ chatIndication: boolean}>) {
      state.chatIndication = action.payload.chatIndication;
    },
    setIsMeetJoined(state, action: PayloadAction<{ isMeetjoined: boolean}>) {
      state.isMeetjoined = action.payload.isMeetjoined;
    },
    setJitsiHostId(state, action: PayloadAction<{jitsiHostId: string | undefined}>){
      state.jitsiHostId = action.payload.jitsiHostId;
    },
    setParticipantLeft(state, action: PayloadAction<{ participantLeft: boolean }>){
       state.participantLeft = action.payload.participantLeft;
    },
    setParticipantJoin(state, action: PayloadAction<{ participantJoin: boolean }>){
      state.participantJoin = action.payload.participantJoin;
    }, 
  },
});

export const { setActivePanel, setApiRef,setChatIndication, setIsMeetJoined, setJitsiHostId, setParticipantJoin, setParticipantLeft } = JitsiMeetSlice.actions;
export default JitsiMeetSlice.reducer;
